<div class="flex items-center justify-center">
  <h1 class="text-5xl text-bunting font-generalsans font-medium tracking-tight">
    Page Not Found
  </h1>
</div>
